import React from 'react';
import { FadeIn } from './FadeIn';
import { Leaf } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-24 bg-sage-light relative overflow-hidden" data-id="element-192">
      {/* Decorative leaf */}
      <div className="absolute -right-20 -top-20 text-sage opacity-10 transform rotate-45 pointer-events-none" data-id="element-193">
        <Leaf className="w-96 h-96" data-id="element-194" />
      </div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-195">
        <FadeIn data-id="element-196">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border-t-4 border-gold" data-id="element-197">
            <div className="flex items-center justify-center mb-8" data-id="element-198">
              <div className="bg-gold-light/30 p-4 rounded-full text-gold-dark" data-id="element-199">
                <Leaf className="w-10 h-10" data-id="element-200" />
              </div>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-center text-forest mb-8" data-id="element-201">
              El Protocolo de Sincronía Hormonal 3.0
            </h2>

            <p className="text-xl text-forest/80 leading-relaxed text-center" data-id="element-202">
              En lugar de pelear contra la caída de estrógenos, ajustamos tu
              nutrición y tus hábitos para estabilizar la glucosa y bajar el
              cortisol. Es un sistema diseñado específicamente para la química
              de la mujer de más de 40 años, priorizando la densidad de
              nutrientes y las señales de calma para tu sistema endocrino.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}